import * as React from "react";
import { UserProvider } from './src/context/UserContext';
import { CartProvider } from './src/context/CartContext';
import { ConsentProvider } from './src/context/ConsentContext';
import CookieBanner from './src/components/structure/CookieBanner/CookieBanner';

export const wrapRootElement = ({ element }) => (
  <ConsentProvider>
    <UserProvider>
      <CartProvider>
        {element}
      </CartProvider>
    </UserProvider>
  </ConsentProvider>
);

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieBanner />
  </>
);
